import { HTTP } from '../../utils/http';

export const SchoolService = {

    getProfileInfo(schoolId) {
        return HTTP.get(`schools/${schoolId}/profile-info`);
    },

    editProfileInfo(schoolId, form) {
        return HTTP.patch(`schools/${schoolId}`, form);
    },

    updateLogo(schoolId, logo) {
        const headers = {'Content-Type': 'multipart/form-data'};
        const formData = new FormData();
        formData.append('logo', logo);
        return HTTP.patch(`schools/${schoolId}/logo`, formData, { headers });
    },

    removeLogo(schoolId) {
        return HTTP.delete(`schools/${schoolId}/logo`);
    },

    setMainContactPerson(schoolId, newContactId) {
        return HTTP.patch(`schools/${schoolId}/contact`, newContactId);
    },

    getLastChildrenSignUps(schoolId) {
        return HTTP.get(`/schools/${schoolId}/last-sign-ups`);
    },

    getSummaryTransactions(schoolId, startDate, endDate) {
        return HTTP.get(`/schools/${schoolId}/summary-transactions?startDate=${startDate}&endDate=${endDate}`);
    },

    getEnrolledChildrenForActivities(schoolId) {
        return HTTP.get(`/schools/${schoolId}/enrolled-children`);
    },

    getTrialPeriodEndDate(schoolId) {
        return HTTP.get(`/schools/${schoolId}/subscription/trial-end-date`);
    },

    toggleInstructorRole(schoolId, userId) {
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/instructor-role`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/school.service.js